
//TODO change IP server
// const IP = "oromie.efspco.ir"

// const PATH = "/EbDelivery/EbtekarWebService.asmx/"
// const IMAGE_PATH = "http://" + IP + ":" + PORT + "/Pictures/"
// const webServicePath = "http://" + IP + ":" + PORT + PATH
const webServicePath = process.env.REACT_APP_IP_SERVER 
const endpoints = {
    GetRatingItems: webServicePath +  '/api/survey/public/rating/items',
    AddRating: webServicePath +  '/api/survey/public/rating',
    GetTripInfo: webServicePath + '/api/survey/public/trip',
    GetDriverPosition: webServicePath + '/api/survey/public/driver-position',
}

export default endpoints